<template>
    <section class="team-hero">
        <div class="hero-media">
            <OptimizedImage
                :webp="heroWebp"
                :avif="heroAvif"
                alt=""
                img-class="hero-image"
                loading="eager"
                fill
            />
            <div class="hero-grain"></div>
            <div class="hero-overlay"></div>
        </div>

        <div class="hero-top">
            <span class="hero-brand">AGH SOLAR BOAT</span>
            <span class="hero-divider"></span>
            <span class="hero-tag">{{ $t('team.page.tag') }}</span>
            <span class="hero-divider hero-divider--hide"></span>
            <span class="hero-since hero-since--hide">{{ $t('team.page.since') }}</span>
        </div>

        <div class="hero-content">
            <span class="hero-eyebrow">{{ $t('team.page.eyebrow') }}</span>
            <h1 class="hero-title" v-html="$t('team.header.line_1')" />
            <p class="hero-lead" v-html="$t('team.header.line_2')" />
        </div>

        <div class="hero-bottom">
            <a href="#sections" class="scroll-link">
                <span>{{ $t('team.page.scroll_sections') }}</span>
                <span class="scroll-arrow">↓</span>
            </a>
        </div>
    </section>
</template>

<script>
import OptimizedImage from '@/components/common/OptimizedImage.vue'

export default {
    name: "HeaderComponent",
    components: { OptimizedImage },
    data() {
        return {
            heroWebp: require('@/assets/img/components/team/zespol2.webp'),
            heroAvif: require('@/assets/img/components/team/zespol2.avif')
        }
    }
}
</script>

<style lang="sass" scoped>
    .team-hero
        position: relative
        width: 100%
        height: 100vh
        min-height: 720px
        overflow: hidden
        background: #0a0828
        color: #fff
        display: flex
        flex-direction: column
        justify-content: space-between
        padding: 110px 0 50px
        font-family: Inter, sans-serif

    .hero-media
        position: absolute
        inset: 0
        z-index: 0

        ::v-deep .optimized-image
            width: 100%
            height: 100%

        .hero-image
            width: 100%
            height: 100%
            object-fit: cover
            filter: blur(2px) saturate(1.1) brightness(0.7) contrast(1.05)
            transform: scale(1.05)

        @media (max-width: 960px)
            .hero-image
                transform: none
                filter: blur(1px) saturate(1.1) brightness(0.7) contrast(1.05)

        .hero-grain
            position: absolute
            inset: 0
            opacity: 0.18
            mix-blend-mode: overlay
            pointer-events: none
            background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.5'/></svg>")

        .hero-overlay
            position: absolute
            inset: 0
            background: linear-gradient(180deg, rgba(10, 8, 40, 0.45) 0%, rgba(10, 8, 40, 0.25) 35%, rgba(10, 8, 40, 0.85) 100%)

    .hero-top
        position: relative
        z-index: 2
        display: flex
        align-items: center
        gap: 18px
        padding: 0 56px
        font-size: 12px
        font-weight: 500
        letter-spacing: 0.18em
        text-transform: uppercase
        color: rgba(255, 255, 255, 0.85)

        .hero-divider
            width: 28px
            height: 1px
            background: rgba(255, 255, 255, 0.5)

    .hero-content
        position: relative
        z-index: 2
        max-width: 1280px
        margin: 0 auto
        padding: 0 56px
        width: 100%

        .hero-eyebrow
            display: inline-block
            font-size: 12px
            font-weight: 500
            letter-spacing: 0.24em
            text-transform: uppercase
            color: rgba(255, 255, 255, 0.7)
            margin-bottom: 28px

        .hero-title
            font-family: Raleway, sans-serif
            font-weight: 900
            font-size: clamp(48px, 7.5vw, 110px)
            line-height: 1.02
            letter-spacing: -0.025em
            margin: 0 0 32px
            color: #fff

            ::v-deep br
                display: block

        .hero-lead
            font-size: clamp(16px, 1.5vw, 19px)
            line-height: 1.6
            font-weight: 400
            color: rgba(255, 255, 255, 0.88)
            max-width: 720px
            margin: 0
            text-indent: 0

    .hero-bottom
        position: relative
        z-index: 2
        display: flex
        justify-content: flex-end
        padding: 0 56px
        max-width: 1280px
        margin: 0 auto
        width: 100%

        .scroll-link
            display: inline-flex
            align-items: center
            gap: 12px
            font-size: 12px
            font-weight: 500
            letter-spacing: 0.18em
            text-transform: uppercase
            color: rgba(255, 255, 255, 0.85)
            text-decoration: none
            padding: 14px 22px
            border: 1px solid rgba(255, 255, 255, 0.4)
            border-radius: 999px
            transition: all 0.2s ease

            &:hover
                background: rgba(255, 255, 255, 0.08)
                border-color: rgba(255, 255, 255, 0.7)

            .scroll-arrow
                font-size: 16px

    @media (max-width: 960px)
        .team-hero
            min-height: 640px
            padding: 100px 0 30px

        .hero-top
            padding: 0 28px
            font-size: 11px
            gap: 14px

            .hero-divider--hide
            .hero-since--hide
                display: none

        .hero-content
            padding: 0 28px

            .hero-title
                font-size: clamp(40px, 11vw, 68px)

        .hero-bottom
            padding: 0 28px
            justify-content: center
</style>
